import nextArrow from "../images/icons/next-arrow.svg"
import prevArrow from "../images/icons/prev-arrow.svg"

import resource1 from "../images/resource1.png"
import resource2 from "../images/resource2.png"
import resource3 from "../images/resource3.png"
import videoclap from "../images/videoclap.jpg"
import videoplay from "../images/videoplay.png"

import photo1 from "../images/photo1.jpg"
import photo2 from "../images/photo2.jpg"

import reportimg1 from "../images/dashboard-report-data1.jpg"
import reportimg2 from "../images/dashboard-report-data2.png"

import cardimg1 from "../images/card_img-1.jpg"
import cardimg2 from "../images/card_img-2.jpg"
import cardimg3 from "../images/card_img-3.jpg"
import cardimg4 from "../images/card_img-4.jpg"
import cardimg5 from "../images/card_img-5.jpg"

import dash_home from "../images/icons/dashboard/Εργασία.svg"
import dash_economy from "../images/icons/dashboard/Θεσμική παρουσία.svg"
import dash_contact from "../images/icons/dashboard/Κοινωνική πολιτική.svg"
import dash_institutional from "../images/icons/dashboard/Οικονομία - Επιχειρηματικότητα.svg"

import economy from "../images/icons/economy.svg"
import facebook from "../images/icons/facebook.svg"
import instagram from "../images/icons/instagram.svg"
import institutional from "../images/icons/institutional.svg"
import social from "../images/icons/social.svg"
import spotify from "../images/icons/spotify.svg"
import tickle from "../images/icons/tickle.svg"
import training from "../images/icons/training.svg"
import twitter from "../images/icons/twitter.svg"
import work from "../images/icons/work.svg"
import youtube from "../images/icons/youtube.svg"

import solidImg from "../images/back.png"
import heroBack from "../images/back.svg"
import facebookP from "../images/facebook.png"
import angleup from "../images/icons/angleup.svg"
import attach from "../images/icons/attach.svg"
import block from "../images/icons/block.svg"
import download from "../images/icons/download.svg"
import download2 from "../images/icons/download2.svg"
import holy from "../images/icons/holy.svg"
import linked from "../images/icons/linked.svg"
import magnifier from "../images/icons/magnifier.svg"
import printer from "../images/icons/printer.svg"
import quote from "../images/icons/quote.svg"
import linkedinP from "../images/linkedin.png"
import map0 from "../images/map0.jpg"
import messagenerP from "../images/messagenger.png"
import twitterP from "../images/twitter.png"

import email from "../images/icons/email.svg"
import fax from "../images/icons/fax.svg"
import tel from "../images/icons/tel.svg"

export const Tel = tel
export const Fax = fax
export const Email = email

export const Quote = quote
export const Block = block

export const Resource1 = resource1
export const Resource2 = resource2
export const Resource3 = resource3

export const HeroBack = heroBack

export const PrevArrow = prevArrow
export const NextArrow = nextArrow

export const dash_Institutional = dash_institutional
export const dash_Economy = dash_economy
export const dash_Home = dash_home
export const dash_Contact = dash_contact

export const Institutional = institutional
export const Training = training
export const Social = social
export const Work = work
export const Economy = economy

export const Facebook = facebook
export const Twitter = twitter
export const Instagram = instagram
export const Youtube = youtube
export const Spotify = spotify

export const Holy = holy
export const Printer = printer
export const Attach = attach
export const Linked = linked
export const AngleUp = angleup

export const Download = download
export const Download2 = download2

export const VideoClap = videoclap
export const VideoPlay = videoplay

export const Photo1 = photo1
export const Photo2 = photo2

export const ReportImg1 = reportimg1
export const ReportImg2 = reportimg2

export const CardImg1 = cardimg1
export const CardImg2 = cardimg2
export const CardImg3 = cardimg3
export const CardImg4 = cardimg4
export const CardImg5 = cardimg5

export const FacebookP = facebookP
export const MessagenerP = messagenerP
export const TwitterP = twitterP
export const LinkedinP = linkedinP
export const MagnifierIcon = magnifier
export const Map0Image = map0
export const SolidImage = solidImg
export const Tickle = tickle
// export const LVic = [lvic1, lvic2, lvic3, lvic4, lvic5, lvic6, lvic7]
// export const CategoryIcon = props => {
//   const { id = undefined } = props
//   if (id === undefined) id = "Θεσμική Παρουσία"
//   switch (id) {
//     case "Θεσμική Παρουσία":
//       return <Institutional />
//   }
// }
